// components/AgentsTable.jsx
import React from "react";
import Table from "rc-app/components/Table";
import Icon from "rc-app/components/Icons";
import { toTitleCase } from "rc-app/utils";

const AgentsTable = ({ agents, className = "" }: any) => {
  const columns = [
    "Agent Name",
    "Last Active",
    "Time Spent",
    "Total Customers",
    "VR Tours Completed",
    "Status",
  ];

  console.log("client agents", agents);

  const formatStatus = (status: any) => {
    // const isActive = status === "active";
    return (
      <div className="flex items-center gap-2">
        {status ? (
          <div className="w-5 h-5 rounded-full justify-center items-center bg-[#008564] p-1">
            <Icon name="ic-check" className="w-4 h-4 " />
          </div>
        ) : (
          // <CheckCircleIcon className="w-5 h-5 text-green-500" />
          // <XCircleIcon className="w-5 h-5 text-red-500" />
          <div className="w-5 h-5 rounded-full justify-center items-center bg-[#ED9A23] p-1">
            <Icon name="ic-exclam" className="w-4 h-4 " />
          </div>
        )}
        <span className={`font-medium text-[#ffffff]`}>
          {/* {status.charAt(0).toUpperCase() + status.slice(1)} */}
          {status ? "Active" : "Inactive"}
        </span>
      </div>
    );
  };

  const renderRow = (agent: any, index: number) => (
    <tr
      key={index}
      className="hover:bg-[#35495E] transition-colors text-[#F4F5F7] text-base border border-[#374B5E]"
    >
      <td className="px-4 py-3  font-semibold">
        <div className="flex items-center gap-2">
          {`${toTitleCase(agent.first_name)} ${toTitleCase(agent.last_name)}`}
        </div>
      </td>
      <td className="px-4 py-3 font-normal">N/A</td>
      <td className="px-4 py-3 font-normal">N/A</td>
      <td className="px-4 py-3 font-normal">{agent.customer_count}</td>
      <td className="px-4 py-3 font-normal">N/A</td>
      <td className="px-4 py-3 font-normal">{formatStatus(agent.is_active)}</td>
    </tr>
  );

  return (
    // <Table
    //   title="Agents"
    //   columns={columns}
    //   data={agents}
    //   renderRow={renderRow}
    //   emptyMessage="No agents available"
    //   className={className}
    // />

    <Table
      title="Agents"
      columns={columns}
      data={agents}
      renderRow={renderRow}
      emptyMessage="No agents available"
      className={className}
      sortableColumns={[0, 1, 2, 3, 4, 5]}
      columnKeys={[
        "first_name",
        "last_active",
        "time_spent",
        "customer_count",
        "vr_tours_completed",
        "is_active",
      ]}
    />
  );
};

export default AgentsTable;
